import { __decorate, __param } from '../../../../../../../external/tslib/tslib.es6.js';
import './media/notificationsActions.css.js';
import { localizeWithPath } from '../../../../nls.js';
import { Action } from '../../../../base/common/actions.js';
import { CLEAR_NOTIFICATION, CLEAR_ALL_NOTIFICATIONS, TOGGLE_DO_NOT_DISTURB_MODE, TOGGLE_DO_NOT_DISTURB_MODE_BY_SOURCE, HIDE_NOTIFICATIONS_CENTER, EXPAND_NOTIFICATION, COLLAPSE_NOTIFICATION } from './notificationsCommands.js';
import { ICommandService } from '../../../../platform/commands/common/commands.service.js';
import { IClipboardService } from '../../../../platform/clipboard/common/clipboardService.service.js';
import { Codicon } from '../../../../base/common/codicons.js';
import { registerIcon } from '../../../../platform/theme/common/iconRegistry.js';
import { ThemeIcon } from '../../../../base/common/themables.js';
const _moduleId = "vs/workbench/browser/parts/notifications/notificationsActions";
const clearIcon = registerIcon('notifications-clear', Codicon.close, ( localizeWithPath(_moduleId, 0, 'Icon for the clear action in notifications.')));
const clearAllIcon = registerIcon('notifications-clear-all', Codicon.clearAll, ( localizeWithPath(_moduleId, 1, 'Icon for the clear all action in notifications.')));
const hideIcon = registerIcon('notifications-hide', Codicon.chevronDown, ( localizeWithPath(_moduleId, 2, 'Icon for the hide action in notifications.')));
const expandIcon = registerIcon('notifications-expand', Codicon.chevronUp, ( localizeWithPath(_moduleId, 3, 'Icon for the expand action in notifications.')));
const collapseIcon = registerIcon('notifications-collapse', Codicon.chevronDown, ( localizeWithPath(_moduleId, 4, 'Icon for the collapse action in notifications.')));
const configureIcon = registerIcon('notifications-configure', Codicon.gear, ( localizeWithPath(_moduleId, 5, 'Icon for the configure action in notifications.')));
const doNotDisturbIcon = registerIcon('notifications-do-not-disturb', Codicon.bellSlash, ( localizeWithPath(_moduleId, 6, 'Icon for the mute all action in notifications.')));
let ClearNotificationAction = class ClearNotificationAction extends Action {
    static { this.ID = CLEAR_NOTIFICATION; }
    static { this.LABEL = ( localizeWithPath(_moduleId, 7, "Clear Notification")); }
    constructor(id, label, commandService) {
        super(id, label, ThemeIcon.asClassName(clearIcon));
        this.commandService = commandService;
    }
    async run(notification) {
        this.commandService.executeCommand(CLEAR_NOTIFICATION, notification);
    }
};
ClearNotificationAction = ( (__decorate([
    ( (__param(2, ICommandService)))
], ClearNotificationAction)));
let ClearAllNotificationsAction = class ClearAllNotificationsAction extends Action {
    static { this.ID = CLEAR_ALL_NOTIFICATIONS; }
    static { this.LABEL = ( localizeWithPath(_moduleId, 8, "Clear All Notifications")); }
    constructor(id, label, commandService) {
        super(id, label, ThemeIcon.asClassName(clearAllIcon));
        this.commandService = commandService;
    }
    async run() {
        this.commandService.executeCommand(CLEAR_ALL_NOTIFICATIONS);
    }
};
ClearAllNotificationsAction = ( (__decorate([
    ( (__param(2, ICommandService)))
], ClearAllNotificationsAction)));
let ToggleDoNotDisturbAction = class ToggleDoNotDisturbAction extends Action {
    static { this.ID = TOGGLE_DO_NOT_DISTURB_MODE; }
    static { this.LABEL = ( localizeWithPath(_moduleId, 9, "Toggle Do Not Disturb Mode")); }
    constructor(id, label, commandService) {
        super(id, label, ThemeIcon.asClassName(doNotDisturbIcon));
        this.commandService = commandService;
    }
    async run() {
        this.commandService.executeCommand(TOGGLE_DO_NOT_DISTURB_MODE);
    }
};
ToggleDoNotDisturbAction = ( (__decorate([
    ( (__param(2, ICommandService)))
], ToggleDoNotDisturbAction)));
let ToggleDoNotDisturbBySourceAction = class ToggleDoNotDisturbBySourceAction extends Action {
    static { this.ID = TOGGLE_DO_NOT_DISTURB_MODE_BY_SOURCE; }
    static { this.LABEL = ( localizeWithPath(_moduleId, 10, "Toggle Do Not Disturb Mode By Source...")); }
    constructor(id, label, commandService) {
        super(id, label);
        this.commandService = commandService;
    }
    async run() {
        this.commandService.executeCommand(TOGGLE_DO_NOT_DISTURB_MODE_BY_SOURCE);
    }
};
ToggleDoNotDisturbBySourceAction = ( (__decorate([
    ( (__param(2, ICommandService)))
], ToggleDoNotDisturbBySourceAction)));
class ConfigureDoNotDisturbAction extends Action {
    static { this.ID = 'workbench.action.configureDoNotDisturbMode'; }
    static { this.LABEL = ( localizeWithPath(_moduleId, 11, "Configure Do Not Disturb...")); }
    constructor(id, label) {
        super(id, label, ThemeIcon.asClassName(doNotDisturbIcon));
    }
}
let HideNotificationsCenterAction = class HideNotificationsCenterAction extends Action {
    static { this.ID = HIDE_NOTIFICATIONS_CENTER; }
    static { this.LABEL = ( localizeWithPath(_moduleId, 12, "Hide Notifications")); }
    constructor(id, label, commandService) {
        super(id, label, ThemeIcon.asClassName(hideIcon));
        this.commandService = commandService;
    }
    async run() {
        this.commandService.executeCommand(HIDE_NOTIFICATIONS_CENTER);
    }
};
HideNotificationsCenterAction = ( (__decorate([
    ( (__param(2, ICommandService)))
], HideNotificationsCenterAction)));
let ExpandNotificationAction = class ExpandNotificationAction extends Action {
    static { this.ID = EXPAND_NOTIFICATION; }
    static { this.LABEL = ( localizeWithPath(_moduleId, 13, "Expand Notification")); }
    constructor(id, label, commandService) {
        super(id, label, ThemeIcon.asClassName(expandIcon));
        this.commandService = commandService;
    }
    async run(notification) {
        this.commandService.executeCommand(EXPAND_NOTIFICATION, notification);
    }
};
ExpandNotificationAction = ( (__decorate([
    ( (__param(2, ICommandService)))
], ExpandNotificationAction)));
let CollapseNotificationAction = class CollapseNotificationAction extends Action {
    static { this.ID = COLLAPSE_NOTIFICATION; }
    static { this.LABEL = ( localizeWithPath(_moduleId, 14, "Collapse Notification")); }
    constructor(id, label, commandService) {
        super(id, label, ThemeIcon.asClassName(collapseIcon));
        this.commandService = commandService;
    }
    async run(notification) {
        this.commandService.executeCommand(COLLAPSE_NOTIFICATION, notification);
    }
};
CollapseNotificationAction = ( (__decorate([
    ( (__param(2, ICommandService)))
], CollapseNotificationAction)));
class ConfigureNotificationAction extends Action {
    static { this.ID = 'workbench.action.configureNotification'; }
    static { this.LABEL = ( localizeWithPath(_moduleId, 15, "More Actions...")); }
    constructor(id, label, notification) {
        super(id, label, ThemeIcon.asClassName(configureIcon));
        this.notification = notification;
    }
}
let CopyNotificationMessageAction = class CopyNotificationMessageAction extends Action {
    static { this.ID = 'workbench.action.copyNotificationMessage'; }
    static { this.LABEL = ( localizeWithPath(_moduleId, 16, "Copy Text")); }
    constructor(id, label, clipboardService) {
        super(id, label);
        this.clipboardService = clipboardService;
    }
    run(notification) {
        return this.clipboardService.writeText(notification.message.raw);
    }
};
CopyNotificationMessageAction = ( (__decorate([
    ( (__param(2, IClipboardService)))
], CopyNotificationMessageAction)));
export { ClearAllNotificationsAction, ClearNotificationAction, CollapseNotificationAction, ConfigureDoNotDisturbAction, ConfigureNotificationAction, CopyNotificationMessageAction, ExpandNotificationAction, HideNotificationsCenterAction, ToggleDoNotDisturbAction, ToggleDoNotDisturbBySourceAction };
